/* eslint-disable @typescript-eslint/naming-convention */
/* eslint-disable no-underscore-dangle */
import React from 'react';
import { CheckCircleOutlined, CloseCircleOutlined } from '@ant-design/icons';
import { Col, Row, message } from 'antd';
import { useHistory } from 'react-router-dom';
import { useMutation } from '@apollo/react-hooks';
import UPDATE_JV_MUTATION, { UpdateJvData, UpdateJvVars } from 'shared/graphql/mutation/updateJv';
import { Button, Text } from 'shared/components';
import { FormValues } from 'views/Setting/Routes/ChartOfAccounts/JV/JvDetail/model/formValues.model';
import { useFormContext } from 'react-hook-form';
import { StyledModal } from './Styles';

type ModalConfirmUpdateProps = {
  visible: boolean;
  onCancel: () => void;
};

const ModalConfirmUpdate: React.FC<ModalConfirmUpdateProps> = (props) => {
  const { onCancel, visible } = props;
  const history = useHistory();
  const { handleSubmit, watch, reset } = useFormContext<FormValues>();

  const [updateJv, { loading }] = useMutation<UpdateJvData, UpdateJvVars>(UPDATE_JV_MUTATION, {
    update: (_cache, { data }) => {
      if (data?.updateJV._id) {
        onCancel();
        message.success('แก้ไขรายการ JV แล้ว');
        history.push('/setting/chart-of-accounts/jv');
        reset();
      }
    },
    onError: (err) => {
      message.error(err.message);
    },
    refetchQueries: () => ['Jv'],
  });

  const submitUpdate = handleSubmit((values) => {
    updateJv({
      variables: {
        _id: values.jvId,
        description: values.description,
        document_date: values.documentDate,
        chartOfAccount: values.chartOfAccountList[0].chartOfAccountId,
        code: values.chartOfAccountList[0].code,
        account_name: values.chartOfAccountList[0].accountName,
        value: values.chartOfAccountList[0].value,
      },
    });
  });

  return (
    <StyledModal
      className="custom-modal"
      title="บันทึกรายการ JV ใช่หรือไม่?"
      visible={visible}
      onCancel={onCancel}
      footer={[
        <Button
          key="okButton"
          icon={<CheckCircleOutlined />}
          color="green"
          onClick={() => submitUpdate()}
          loading={loading}
          disabled={loading}
        >
          ตกลง
        </Button>,
        <Button
          key="cancelButton"
          icon={<CloseCircleOutlined />}
          onClick={onCancel}
          disabled={loading}
        >
          ยกเลิก
        </Button>,
      ]}
    >
      <Row>
        <Col span={6}>รหัส JV:</Col>
        <Col span={18}>
          <Text strong>{watch('jvNumber')}</Text>
        </Col>
      </Row>
      <Row>
        <Col span={6}>คำอธิบาย:</Col>
        <Col span={18}>
          <Text strong>{watch('description')}</Text>
        </Col>
      </Row>
    </StyledModal>
  );
};

export default ModalConfirmUpdate;
